import MuiCard from "@mui/material/Card";
import type { CardProps as MuiCardProps } from "@mui/material/Card";
import MuiCardHeader from "@mui/material/CardHeader";
import MuiCardContent from "@mui/material/CardContent";

// Permitir todas as props do MuiCard, incluindo sx
export function Card({ children, ...props }: MuiCardProps) {
  return <MuiCard {...props}>{children}</MuiCard>;
}
export const CardHeader = MuiCardHeader;
export const CardContent = MuiCardContent;
Card.Header = CardHeader;
Card.Content = CardContent; 